import type { StateCreator } from "zustand";
import type { RunControlState } from "./index";

export interface MetricsSlice {
  queueLen: number;
  stackLen: number;
  suspendedLen: number;
  setMetrics: (metrics: Partial<Pick<MetricsSlice, "queueLen" | "stackLen" | "suspendedLen">>) => void;
  clearMetrics: () => void;
}

export const createMetricsSlice: StateCreator<
  RunControlState,
  [["zustand/immer", never], ["zustand/subscribeWithSelector", never]],
  [],
  MetricsSlice
> = (set) => ({
  queueLen: 0,
  stackLen: 0,
  suspendedLen: 0,

  setMetrics: (metrics) =>
    set((state) => {
      if (metrics.queueLen !== undefined) state.queueLen = metrics.queueLen;
      if (metrics.stackLen !== undefined) state.stackLen = metrics.stackLen;
      if (metrics.suspendedLen !== undefined) state.suspendedLen = metrics.suspendedLen;
    }),

  clearMetrics: () =>
    set((state) => {
      state.queueLen = 0;
      state.stackLen = 0;
      state.suspendedLen = 0;
    }),
});
